import request from '@/utils/request'
// 定向登录
export function loginV2 (data) {
    return request({
        url: '/yongUser/pclogin_v2',
        method: 'post',
        data
    })
}
// 非定向登录
export function login (data) {
    return request({
        url: '/yongUser/pclogin',
        method: 'post',
        data
    })
}

export function formSubmit (query) {
    return request({
        url: '/public/form/submit',
        method: 'GET',
        params: query
    })
}
export function examDetail (query) {
    return request({
        url: '/yongExam/examDetail',
        method: 'GET',
        params: query
    })
}
export function examStart (query) {
    return request({
        url: '/yongExam/examStart',
        method: 'GET',
        params: query
    })
}
export function examEnd (data) {
    return request({
        url: '/yongExam/examEnd',
        method: 'post',
        data
    })
}
/**
 * 
 * @param {校区列表} query 
 * @returns 
 */
export function getAreasList (query) {
    return request({
        url: '/yongStudent/areasV2',
        method: 'GET',
        params: query
    })
}
/**
 * 
 * @param {学校列表} query 
 * @returns 
 */
 export function getExamDetail (query) {
    return request({
        url: '/yongExam/examDetail',
        method: 'GET',
        params: query
    })
}
/**
 * 
 * @param {获取年级和班级} query 
 * @returns 
 */
export function getGradeAndStudyClass (query) {
    return request({
        url: '/yongStudent/getGradeAndStudyClass',
        method: 'GET',
        params: query
    })
}

/**
 * 
 * @param {获取年级和班级} query 
 * @returns 
 */
export function getGradeAndStudyClassV5 (query) {
    return request({
        url: '/yongStudent/getGradeAndStudyClassV5',
        method: 'GET',
        params: query
    })
}

// 根据信息查询学生数据
export function getProfilesByInfo (data) {
    return request({
        url: '/yongStudent/findProfilesByInfo',
        method: 'post',
        data
    })
}

// 根据信息查询学生数据（和教育）
export function findProfilesByInfoSn (data) {
    return request({
        url: '/yongStudent/findProfilesByInfoSn',
        method: 'post',
        data
    })
}

// 补充姓名（全通）
export function updateProfileName (data) {
    return request({
        url: '/yongStudent/updateProfileNamePc',
        method: 'post',
        data
    })
}